<template>
	<div>
		<custom-light-box :items="videos" :index="index" :effect="'fade'" @close="index = null" />

		<b-tabs v-model="indexTab" nav-wrapper-class="card pt-1 px-2 lg-px-1 mb-2" v-if="origin === 'main'">
			<b-tab>
				<template #title>
					Topes
					<b-badge :variant="indexTab === 0 ? 'primary' : 'light-primary'" style="margin-left: 0.5rem">
						{{ getCounterTope }}
					</b-badge>
				</template>
			</b-tab>
			<b-tab>
				<template #title>
					Torneos
					<b-badge :variant="indexTab === 1 ? 'primary' : 'light-primary'" style="margin-left: 0.5rem">
						{{ getCounterTournament }}
					</b-badge>
				</template>
			</b-tab>
			<b-tab>
				<template #title>
					Capeadas
					<b-badge :variant="indexTab === 2 ? 'primary' : 'light-primary'" style="margin-left: 0.5rem">
						{{ getCapeadaCounter }}
					</b-badge>
				</template>
			</b-tab>
		</b-tabs>

		<b-card no-body class="mb-1">
			<div class="m-2">
				<div v-if="!id_specimen" class="mx-2 mb-2">
					<b-row>
						<b-col
							cols="12"
							sm="6"
							class="d-flex align-items-center justify-content-center justify-content-sm-start"
						>
							<span class="text-muted">
								Mostrando {{ start_page }} a {{ to_page }} de {{ total_data }} registros
							</span>
						</b-col>
						<!-- Pagination -->
						<b-col
							cols="12"
							sm="6"
							class="d-flex align-items-center justify-content-center justify-content-sm-end"
						>
							<b-pagination
								v-model="current_page"
								:total-rows="total_data"
								:per-page="perpage"
								first-number
								last-number
								class="mb-0 mt-1 mt-sm-0"
								prev-class="prev-item"
								next-class="next-item"
							>
								<template #prev-text>
									<feather-icon icon="ChevronLeftIcon" size="18" />
								</template>
								<template #next-text>
									<feather-icon icon="ChevronRightIcon" size="18" />
								</template>
							</b-pagination>
						</b-col>
					</b-row>
				</div>
				<!-- Table Top -->
				<b-row>
					<!-- Per Page -->
					<b-col
						v-if="!id_specimen"
						cols="12"
						md="4"
						class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
					>
						<label>Mostrar</label>
						<v-select
							v-model="perpage"
							:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
							:options="perPageOptions"
							:clearable="false"
							class="per-page-selector d-inline-block mx-50"
						/>
						<label class="mr-2">registros</label>
						<feather-icon class="cursor-pointer" icon="RefreshCcwIcon" size="20" @click="refresh" />
					</b-col>
					<b-col v-else cols="12" md="4" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
						<label class="mr-2">Refrescar</label>
						<feather-icon class="cursor-pointer" icon="RefreshCcwIcon" size="20" @click="refresh" />
					</b-col>
					<b-col cols="12" md="2" class="d-flex align-items-center justify-content-end mb-1 mb-md-0">
						<b-button
							v-if="items.some((item) => item.selected) && isAdmin"
							variant="danger"
							@click="removedConfrontationVideoMultiple"
						>
							Eliminar seleccionados
						</b-button>
					</b-col>
					<b-col cols="12" md="6">
						<div class="d-flex align-items-center justify-content-end">
							<b-form-input
								v-model="search_input"
								class="d-inline-block mr-1"
								placeholder="Placa / alias / cintillo en la ala"
								@keypress.enter="resetSearch"
							/>
							<template v-if="!id_specimen">
								<b-dropdown
									variant="outline-primary"
									class="ml-1"
									v-if="(isAdmin || isPreparador || isSupervisor) && indexTab === 0"
								>
									<template #button-content>
										<span class="text-nowrap">Agregar Video</span>
									</template>
									<b-dropdown-item @click="modalAddVideoBySpecimen = true">
										Individual
									</b-dropdown-item>
									<b-dropdown-item @click="showTopesMultiplesModal = true">
										Topes Múltiples
									</b-dropdown-item>
								</b-dropdown>
								<b-button
									v-if="(isAdmin || isPreparador || isSupervisor) && indexTab === 0"
									variant="outline-primary"
									class="ml-1"
									@click="showTopeGroupsModal = true"
								>
									<div class="d-flex align-items-center justify-content-between" style="gap: 0.5rem">
										<b-badge v-if="draftCounter > 0" variant="danger">{{ draftCounter }}</b-badge>
										<div>Pendientes</div>
									</div>
								</b-button>
								<b-button
									v-if="(isAdmin || isPreparador || isSupervisor) && [0, 1].includes(indexTab)"
									variant="outline-primary"
									class="ml-1"
									@click="
										filterByScore = !filterByScore
										init()
										getCounters()
									"
								>
									<span class="text-nowrap">
										{{ filterByScore ? "Quitar Filtro" : "Filtrar Sin calificar" }}
									</span>
								</b-button>
								<b-button
									v-if="(isAdmin || isPreparador || isSupervisor) && indexTab === 2"
									variant="outline-primary"
									class="ml-1"
									@click="modalAddVideoBySpecimen = true"
								>
									<span class="text-nowrap">Agregar Video</span>
								</b-button>
								<button
									v-if="!id_specimen"
									@click="sidebarFilters = !sidebarFilters"
									class="ml-1 btn btn-outline-primary btn-buscar-placa"
								>
									<feather-icon icon="FilterIcon" />
								</button>
							</template>
						</div>
					</b-col>
				</b-row>
			</div>

			<!-- {{  items}} -->

			<!-- Toggle View Button -->
			<div class="mx-2 mb-2 d-flex justify-content-end">
				<b-button-group>
					<b-button
						:variant="viewMode === 'card' ? 'primary' : 'outline-primary'"
						@click="viewMode = 'card'"
						v-b-tooltip.hover="'Vista de tarjetas'"
					>
						<feather-icon icon="GridIcon" size="18" />
					</b-button>
					<b-button
						:variant="viewMode === 'table' ? 'primary' : 'outline-primary'"
						@click="viewMode = 'table'"
						v-b-tooltip.hover="'Vista de tabla'"
					>
						<feather-icon icon="ListIcon" size="18" />
					</b-button>
				</b-button-group>
			</div>

			<!-- Card View -->
			<div v-if="viewMode === 'card'" class="videos-cards-grid px-2">
				<b-card v-for="(item, index) in items" :key="`card-${index}`" class="video-card mb-2" body-class="p-0">
					<!-- Header with video -->
					<div
						class="video-card-header d-flex justify-content-center align-items-center position-relative p-0"
					>
						<div
							v-if="item.video.status == '2' && (item.video.url || item.video.aws_hls_url)"
							class="position-relative w-100"
						>
							<span @click="viewSpecimen(item, index)" style="cursor: pointer" class="d-block">
								<img :src="item.video.thumb" class="video-thumbnail-card" alt="Video thumbnail" />
								<!-- Play Icon Overlay -->
								<div class="video-play-overlay">
									<feather-icon icon="PlayIcon" size="25" />
								</div>
								<div class="video-duration-badge">{{ item.video.duration }}</div>
								<!-- Result Badge for tournaments in video -->
								<div v-if="indexTab === 1 && item.result" class="video-result-badge">
									<b-badge
										v-if="item.result.id == 1"
										variant="success"
										class="tournament-result-badge"
									>
										TRIUNFO
									</b-badge>
									<b-badge
										v-else-if="item.result.id == 2"
										variant="warning"
										class="tournament-result-badge"
									>
										EMPATE
									</b-badge>
									<b-badge
										v-else-if="item.result.id == 3"
										variant="danger"
										class="tournament-result-badge"
									>
										DERROTA
									</b-badge>
								</div>
							</span>
							<div class="video-download-overlay">
								<feather-icon
									class="cursor-pointer text-white"
									icon="DownloadIcon"
									size="20"
									v-b-tooltip.hover="`Descargar`"
									@click="downloadVideo(item)"
									v-if="
										isAdmin &&
										item.video.status == '2' &&
										(item.video.url || item.video.aws_hls_url)
									"
								/>
							</div>
							<div class="video-edit-overlay">
								<feather-icon
									@click="selectBattle(item)"
									class="cursor-pointer text-white"
									icon="Edit3Icon"
									size="18"
								/>
							</div>
						</div>
						<div v-else-if="item.video.s3" class="text-center">
							<p class="mb-0">Procesando video</p>
						</div>
						<div v-else class="text-center">
							<div v-if="item.category != 'torneo'">
								<b-button variant="outline-primary" size="sm" @click="selectBattle(item)">
									<feather-icon icon="PlusIcon" size="16" />
									Subir video
								</b-button>
							</div>
							<UploadFightVideo v-else @refresh="refresh" :info="item" />
						</div>
					</div>

					<!-- Specimens Info -->
					<!-- Vista para TOPES (Tab 0) -->
					<div v-if="indexTab === 0" class="specimens-info-wrapper mb-2 px-2 pt-2">
						<!-- Local Specimen -->
						<div class="specimen-section">
							<div class="specimen-section-label">
								EJEMPLAR
								<v-icon
									name="gi-boxing-glove"
									scale="1"
									class="text-danger ml-1"
									style="transform: rotate(270deg)"
								/>
							</div>
							<div class="specimen-box local-specimen">
								<template v-if="item.local">
									<template v-if="item.local && item.local.type == 'specimen'">
										<div class="d-flex flex-column align-items-end w-100">
											<div
												v-if="!!item.local.status"
												class="d-flex align-items-center justify-content-center status-badge"
												v-b-tooltip.hover="
													`${item.local.status} ${item.local.trainingStatusName} ${
														item.local.training_group_id ? item.local.trainingGroupName : ''
													}`
												"
											>
												<feather-icon
													size="10"
													:icon="
														item.local.in_galpon === 1 ? 'CheckCircleIcon' : 'XCircleIcon'
													"
												></feather-icon>
												<span class="badge-glow">
													{{ item.local.status }}
												</span>
											</div>
											<div class="d-flex justify-content-between w-100">
												<SpecimenPlate
													:specimen="{
														plate: item.local.plate,
														alias: item.local.alias,
														id: item.local.id,
														thumb: item.local.thumb,
														image: item.local.url,
													}"
													:is_specimen="item.local.type == 'specimen'"
													is_icon
													show_details_icon
													@image-clicked="handleImageClicked"
												/>

												<div class="d-flex flex-column align-items-end justify-content-end">
													<div
														class="position-relative"
														v-if="item.local && item.local.type == 'specimen'"
													>
														<feather-icon
															@click="
																item.local.incidences_qty === 0
																	? null
																	: openIncidenceModal(item.local)
															"
															v-b-tooltip.hover="
																item.local.incidences_qty > 0
																	? 'Ver incidencias (Local)'
																	: 'Sin incidencias (Local)'
															"
															:class="
																item.local.incidences_qty === 0
																	? 'text-muted'
																	: 'text-primary cursor-pointer'
															"
															icon="AlertOctagonIcon"
															size="20"
														/>
														<span
															v-if="item.local.incidences_qty > 0"
															class="incidences-counter-footer"
														>
															{{ item.local.incidences_qty }}
														</span>
													</div>
												</div>
											</div>
										</div>
									</template>

									<template v-else>
										<div class="d-flex align-items-center justify-content-between w-100">
											<SpecimenPlate
												:specimen="{
													plate: item.local.cintillo,
													alias: item.local.alias,
													id: item.local.id,
												}"
												:is_specimen="item.local.type == 'specimen'"
												is_icon
												show_details_icon
												@image-clicked="handleImageClicked"
											/>
										</div>
									</template>

									<!-- Motivo -->
									<div class="specimen-info-badge">
										<div class="info-badge-label">Motivo</div>
										<div class="info-badge-value">
											<span v-if="item.reason_local && item.reason_local.id">
												{{ item.reason_local.name }}
											</span>
											<span v-else>---</span>
										</div>
									</div>

									<!-- Calificación -->
									<template v-if="!id_specimen">
										<template
											v-if="
												item.rival_specimens_score.filter((score) => score.id == item.local.id)
													.length > 0
											"
										>
											<div
												class="specimen-score-card"
												v-for="(specimen, idx) in item.rival_specimens_score.filter(
													(score) => score.id == item.local.id
												)"
												:key="`local-score-${idx}`"
												@click="openEditQualifyModal(item, item.local, specimen.user)"
											>
												<div class="score-label">Calificación</div>
												<div class="score-value-container">
													<span class="score-user">{{ specimen.user_name }}</span>
													<div class="score-value">
														<span class="score-number">
															{{
																specimen.score ? Number(specimen.score).toFixed(1) : "-"
															}}
														</span>
														<feather-icon class="score-star" size="16" icon="StarIcon" />
													</div>
												</div>
											</div>
										</template>
										<template v-else>
											<div class="specimen-score-card specimen-score-card-disabled">
												<div class="score-label">Calificación</div>
												<div class="score-value-container">
													<span class="score-user">Sin calificación</span>
													<div class="score-value">
														<span class="score-number">-</span>
														<feather-icon class="score-star" size="16" icon="StarIcon" />
													</div>
												</div>
											</div>
										</template>
									</template>

									<!-- Preparador -->
									<div class="specimen-info-badge">
										<div class="info-badge-label">Preparador</div>
										<div class="info-badge-value">
											{{ item.local.trainer || "---" }}
										</div>
									</div>
								</template>
								<template v-else>
									<p class="mb-0 text-center">Sin ejemplar</p>
								</template>
							</div>
						</div>

						<!-- Rival Specimen -->
						<div class="specimen-section" v-if="indexTab !== 2 && tabCategory != 4">
							<div class="specimen-section-label">
								RIVAL
								<v-icon
									name="gi-boxing-glove"
									scale="1"
									class="ml-1"
									style="transform: rotate(270deg); color: blue"
								/>
							</div>
							<div class="specimen-box rival-specimen">
								<template v-if="item.rival">
									<!-- Type specimen -->
									<template v-if="item.rival && item.rival.type == 'specimen'">
										<div class="d-flex flex-column align-items-end w-100">
											<div
												v-if="!!item.rival.status"
												class="d-flex align-items-center justify-content-center status-badge"
												v-b-tooltip.hover="
													`${item.rival.status} ${item.rival.trainingStatusName} ${
														item.rival.training_group_id ? item.rival.trainingGroupName : ''
													}`
												"
											>
												<feather-icon
													size="10"
													:icon="
														item.rival.in_galpon === 1 ? 'CheckCircleIcon' : 'XCircleIcon'
													"
												></feather-icon>
												<span class="badge-glow">
													{{ item.rival.status }}
												</span>
											</div>
											<div class="d-flex w-100 justify-content-between">
												<SpecimenPlate
													:specimen="{
														plate: item[item.rival.id == id_specimen ? 'local' : 'rival']
															.plate,
														alias: item[item.rival.id == id_specimen ? 'local' : 'rival']
															.alias,
														id: item[item.rival.id == id_specimen ? 'local' : 'rival'].id,
														thumb: item[item.rival.id == id_specimen ? 'local' : 'rival']
															.thumb,
														image: item[item.rival.id == id_specimen ? 'local' : 'rival']
															.url,
													}"
													:is_specimen="item.rival.type == 'specimen'"
													is_icon
													show_details_icon
													@image-clicked="handleImageClicked"
												/>
												<div class="d-flex flex-column align-items-end justify-content-end">
													<div
														class="position-relative"
														v-if="
															item.rival &&
															item.rival.type == 'specimen' &&
															indexTab !== 2 &&
															tabCategory != 4
														"
													>
														<feather-icon
															@click="
																item[item.rival.id == id_specimen ? 'local' : 'rival']
																	.incidences_qty === 0
																	? null
																	: openIncidenceModal(
																			item[
																				item.rival.id == id_specimen
																					? 'local'
																					: 'rival'
																			]
																	  )
															"
															:class="
																item[item.rival.id == id_specimen ? 'local' : 'rival']
																	.incidences_qty === 0
																	? 'text-muted'
																	: 'text-primary cursor-pointer'
															"
															v-b-tooltip.hover="
																item[item.rival.id == id_specimen ? 'local' : 'rival']
																	.incidences_qty > 0
																	? 'Ver incidencias (Rival)'
																	: 'Sin incidencias (Rival)'
															"
															icon="AlertOctagonIcon"
															size="20"
														/>
														<span
															v-if="
																item[item.rival.id == id_specimen ? 'local' : 'rival']
																	.incidences_qty > 0
															"
															class="incidences-counter-footer"
														>
															{{
																item[item.rival.id == id_specimen ? "local" : "rival"]
																	.incidences_qty
															}}
														</span>
													</div>
												</div>
											</div>
										</div>

										<!-- Motivo Rival -->
										<div
											v-if="item.reason_rival && item.reason_rival.id"
											class="specimen-info-badge"
										>
											<div class="info-badge-label">Motivo</div>
											<div class="info-badge-value">
												{{
													item.rival.id == id_specimen
														? item.reason_local.name
														: item.reason_rival.name
												}}
											</div>
										</div>

										<!-- Calificación Rival -->
										<template v-if="!id_specimen">
											<template
												v-if="
													item.rival_specimens_score.filter(
														(score) => score.id == item.rival.id
													).length > 0
												"
											>
												<div
													class="specimen-score-card"
													v-for="(specimen, idx) in item.rival_specimens_score.filter(
														(score) => score.id == item.rival.id
													)"
													:key="`rival-score-${idx}`"
													@click="openEditQualifyModal(item, item.rival, specimen.user)"
												>
													<div class="score-label">Calificación</div>
													<div class="score-value-container">
														<span class="score-user">{{ specimen.user_name }}</span>
														<div class="score-value">
															<span class="score-number">
																{{
																	specimen.score
																		? Number(specimen.score).toFixed(1)
																		: "-"
																}}
															</span>
															<feather-icon
																class="score-star"
																size="16"
																icon="StarIcon"
															/>
														</div>
													</div>
												</div>
											</template>
											<template v-else>
												<div class="specimen-score-card specimen-score-card-disabled">
													<div class="score-label">Calificación</div>
													<div class="score-value-container">
														<span class="score-user">Sin calificación</span>
														<div class="score-value">
															<span class="score-number">-</span>
															<feather-icon
																class="score-star"
																size="16"
																icon="StarIcon"
															/>
														</div>
													</div>
												</div>
											</template>
										</template>

										<!-- Preparador Rival -->
										<div class="specimen-info-badge">
											<div class="info-badge-label">Preparador</div>
											<div class="info-badge-value">
												{{
													item[item.rival.id == id_specimen ? "local" : "rival"].trainer ||
													"---"
												}}
											</div>
										</div>
									</template>

									<!-- Type chick -->
									<template v-else-if="item.rival && item.rival.type == 'chick'">
										<div class="text-center">
											<SpecimenPlate
												:specimen="{
													plate: item.rival.cintillo,
													alias: item.rival.alias,
													id: item.rival.id,
												}"
												:is_specimen="item.rival.type == 'specimen'"
												is_icon
												show_details_icon
												@image-clicked="handleImageClicked"
											/>
										</div>

										<!-- Calificación Rival (Chick) -->
										<template v-if="!id_specimen">
											<div
												class="specimen-score-card"
												v-for="(specimen, idx) in item.rival_specimens_score.filter(
													(score) => score.id == item.rival.id
												)"
												:key="`rival-chick-score-${idx}`"
												@click="openEditQualifyModal(item, item.rival, specimen.user)"
											>
												<div class="score-label">Calificación</div>
												<div class="score-value-container">
													<span class="score-user">{{ specimen.user_name }}</span>
													<div class="score-value">
														<span class="score-number">
															{{
																specimen.score ? Number(specimen.score).toFixed(1) : "-"
															}}
														</span>
														<feather-icon class="score-star" size="16" icon="StarIcon" />
													</div>
												</div>
											</div>
										</template>

										<!-- Motivo Rival (Chick) -->
										<div
											v-if="item.reason_rival && item.reason_rival.id"
											class="specimen-info-badge mt-2"
										>
											<div class="info-badge-label">Motivo</div>
											<div class="info-badge-value">
												{{ item.reason_rival.name }}
											</div>
										</div>
									</template>

									<!-- Type other -->
									<template v-else-if="item.rival && item.rival.type == 'other'">
										<div class="text-center">
											<p class="mb-0 font-weight-bold">{{ item.rival.name }}</p>
										</div>

										<!-- Calificación Rival (Other) -->
										<template v-if="!id_specimen">
											<div
												class="specimen-score-card"
												v-for="(specimen, idx) in item.rival_specimens_score.filter(
													(score) => score.id == item.rival.id
												)"
												:key="`rival-other-score-${idx}`"
												@click="openEditQualifyModal(item, item.rival, specimen.user)"
											>
												<div class="score-label">Calificación</div>
												<div class="score-value-container">
													<span class="score-user">{{ specimen.user_name }}</span>
													<div class="score-value">
														<span class="score-number">
															{{
																specimen.score ? Number(specimen.score).toFixed(1) : "-"
															}}
														</span>
														<feather-icon class="score-star" size="16" icon="StarIcon" />
													</div>
												</div>
											</div>
										</template>

										<!-- Motivo Rival (Other) -->
										<div
											v-if="item.reason_rival && item.reason_rival.id"
											class="specimen-info-badge mt-2"
										>
											<div class="info-badge-label">Motivo</div>
											<div class="info-badge-value">
												{{ item.reason_rival.name }}
											</div>
										</div>
									</template>
								</template>
								<template v-else>
									<p class="mb-0 text-center">Sin rival</p>
								</template>
							</div>
						</div>
					</div>

					<!-- Vista para TORNEOS (Tab 1) -->
					<div v-if="indexTab === 1" class="tournament-info-wrapper mb-2 px-2 pt-2">
						<div class="tournament-specimen-section tournament-specimen-box">
							<div class="d-flex justify-content-between mb-1">
								<div class="specimen-section-label mb-0">EJEMPLAR</div>
								<div
									v-if="!!item.local.status"
									class="d-flex align-items-center justify-content-center status-badge"
									v-b-tooltip.hover="
										`${item.local.status} ${item.local.trainingStatusName} ${
											item.local.training_group_id ? item.local.trainingGroupName : ''
										}`
									"
								>
									<feather-icon
										size="10"
										:icon="item.local.in_galpon === 1 ? 'CheckCircleIcon' : 'XCircleIcon'"
									></feather-icon>
									<span class="badge-glow">
										{{ item.local.status }}
									</span>
								</div>
							</div>
							<div>
								<template v-if="item.local && item.local.type == 'specimen'">
									<div class="d-flex align-items-start w-100" style="gap: 1rem">
										<!-- Specimen Plate -->
										<div class="tournament-specimen-plate">
											<SpecimenPlate
												:specimen="{
													plate: item.local.plate,
													alias: item.local.alias,
													id: item.local.id,
													thumb: item.local.thumb,
													image: item.local.url,
												}"
												isColumn
												:is_specimen="item.local.type == 'specimen'"
												is_icon
												show_details_icon
												@image-clicked="handleImageClicked"
											/>
										</div>

										<!-- Tournament Details Grid -->
										<div class="tournament-details-grid">
											<!-- Row 1: Calificación y Rival lado a lado -->
											<div class="tournament-row-split">
												<!-- Calificación Card (50%) -->
												<div class="tournament-detail-card-half">
													<template
														v-if="
															item.rival_specimens_score.filter(
																(score) => score.id == item.local.id
															).length > 0
														"
													>
														<div
															v-for="(specimen, idx) in item.rival_specimens_score.filter(
																(score) => score.id == item.local.id
															)"
															:key="`tournament-score-${idx}`"
															class="tournament-qualification-card"
															@click="
																openEditQualifyModal(item, item.local, specimen.user)
															"
														>
															<div class="qualification-label">Calificación</div>
															<div class="qualification-content">
																<feather-icon
																	class="qualification-star"
																	size="18"
																	icon="StarIcon"
																/>
																<span class="qualification-score">
																	{{
																		specimen.score
																			? Number(specimen.score).toFixed(1)
																			: "-"
																	}}
																</span>
															</div>
															<span class="qualification-user">
																{{ specimen.user_name }}
															</span>
														</div>
													</template>
													<template v-else>
														<div class="tournament-qualification-card disabled">
															<div class="qualification-label">Calificación</div>
															<div class="qualification-content">
																<feather-icon
																	class="qualification-star"
																	size="18"
																	icon="StarIcon"
																/>
																<span class="qualification-score">-</span>
															</div>
															<span class="qualification-user">Sin calificación</span>
														</div>
													</template>
												</div>

												<!-- Rival Card (50%) -->
												<div class="tournament-detail-card-half">
													<div class="tournament-rival-card">
														<div class="rival-label">Rival</div>
														<div class="rival-content">
															<span class="rival-name">
																{{
																	item.rival && item.rival.name
																		? item.rival.name
																		: "---"
																}}
															</span>
														</div>
													</div>
												</div>
											</div>

											<!-- Row 2: Preparador (sin fondo de color) -->
											<div class="tournament-preparador-row">
												<div class="preparador-label">Preparador</div>
												<div class="preparador-value">
													{{ item.local.trainer || "---" }}
												</div>
											</div>
										</div>
									</div>
								</template>
							</div>
						</div>
					</div>

					<!-- Vista para CAPEADAS (Tab 2) -->
					<div v-if="indexTab === 2" class="capeadas-info-wrapper mb-2 px-2 pt-2">
						<div class="capeadas-specimen-section">
							<div class="specimen-section-label">EJEMPLAR</div>
							<template v-if="item.local && item.local.type == 'specimen'">
								<div class="d-flex align-items-start w-100" style="gap: 1rem">
									<!-- Specimen Plate -->
									<div class="capeadas-specimen-plate">
										<SpecimenPlate
											:specimen="{
												plate: item.local.plate,
												alias: item.local.alias,
												id: item.local.id,
												thumb: item.local.thumb,
												image: item.local.url,
											}"
											:is_specimen="item.local.type == 'specimen'"
											is_icon
											show_details_icon
											@image-clicked="handleImageClicked"
										/>
									</div>

									<!-- Capeadas Details Grid -->
									<div class="capeadas-details-grid">
										<!-- Preparador -->
										<div class="capeadas-detail-row">
											<div class="capeadas-label">Preparador</div>
											<div class="capeadas-value">
												{{ item.local.trainer || "---" }}
											</div>
										</div>

										<!-- Estado Badge -->
										<div v-if="!!item.local.status" class="capeadas-detail-row">
											<div class="capeadas-label">Estado</div>
											<div class="capeadas-status-container">
												<div
													v-if="!!item.local.status"
													class="d-flex align-items-center justify-content-center status-badge"
													v-b-tooltip.hover="
														`${item.local.status} ${item.local.trainingStatusName} ${
															item.local.training_group_id
																? item.local.trainingGroupName
																: ''
														}`
													"
												>
													<feather-icon
														size="10"
														:icon="
															item.local.in_galpon === 1
																? 'CheckCircleIcon'
																: 'XCircleIcon'
														"
													></feather-icon>
													<span class="badge-glow">
														{{ item.local.status }}
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</template>
							<template v-else>
								<p class="mb-0 text-center">Sin ejemplar</p>
							</template>
						</div>
					</div>
					<!-- Card Footer -->
					<div class="video-card-footer card-footer-info" style="border-top: 1px solid #ebe9f1">
						<!-- Left: User and dates -->
						<div class="d-flex flex-column">
							<span v-if="item.date" class="text-capitalize">
								<strong>Fecha:</strong>
								{{ item.date | myGlobalDayShort }}
							</span>
							<span>
								<strong>{{ item.created.user }}</strong>
							</span>
							<span>
								{{ item.created.date | myGlobalDateTime }}
							</span>
						</div>

						<!-- Right: Actions -->
						<div class="d-flex align-items-center" v-if="isAdmin || isSupervisor || isPreparador">
							<template v-if="indexTab !== 0">
								<!-- Incidencia Local -->
								<b-button
									v-if="item.local && item.local.type == 'specimen' && item.local.incidences_qty > 0"
									@click="item.local.incidences_qty === 0 ? null : openIncidenceModal(item.local)"
									v-b-tooltip.hover="
										item.local.incidences_qty > 0
											? 'Ver incidencias (Local)'
											: 'Sin incidencias (Local)'
									"
									variant="flat-primary"
								>
									<div class="position-relative">
										<feather-icon icon="AlertOctagonIcon" size="20" />
										<span v-if="item.local.incidences_qty > 0" class="incidences-counter-footer">
											{{ item.local.incidences_qty }}
										</span>
									</div>
								</b-button>
							</template>
							<b-button
								v-if="isAdmin && item.video.status == '2' && (item.video.url || item.video.aws_hls_url)"
								v-b-tooltip.hover="`Descargar`"
								@click="downloadVideo(item)"
								variant="flat-primary"
							>
								<feather-icon icon="DownloadIcon" size="20" />
							</b-button>
							<template v-if="item.video.thumb">
								<b-button
									v-b-tooltip.hover="`Actualizar`"
									@click="selectVideoToUpdate(item)"
									variant="flat-primary"
								>
									<feather-icon icon="EditIcon" size="20" />
								</b-button>
								<QualifyTope
									:video="{ ...item.video, uid: item.video.url }"
									:info="{
										category: item.category,
										_curSpecimen: item.local,
										specimen: item.rival,
										rival_specimens_score: item.rival_specimens_score,
										training_rival: item.training_rival,
										confrontation_id: item.confrontation_id,
									}"
									v-if="tabCategory !== 4 && indexTab !== 2 && canQualifyTope(item)"
									:training_tope_id="0"
									@refresh="refresh"
								/>
							</template>
							<b-button
								v-if="item.category != 'torneo' && (isAdmin || isSupervisor || isPreparador)"
								v-b-tooltip.hover="`Eliminar`"
								@click="removedConfrontationVideo(item)"
								variant="flat-primary"
							>
								<FeatherIcon icon="TrashIcon" size="20" />
							</b-button>
						</div>
					</div>
				</b-card>

				<!-- Empty state -->
				<div v-if="items.length == 0" class="text-center w-100 py-3">
					<p class="font-weight-bolder mb-0">Sin videos que mostrar</p>
				</div>
			</div>

			<!-- Table View -->
			<div v-else class="table-responsive">
				<b-table-simple class="position-relative">
					<b-thead>
						<b-tr class="text-center">
							<b-th class="p-1" v-if="!id_specimen"></b-th>
							<b-th class="p-1" v-if="id_specimen">PUNTAJE</b-th>
							<b-th class="p-1">VIDEO</b-th>
							<b-th class="p-1" v-if="!id_specimen">EJEMPLAR</b-th>
							<b-th class="p-1" v-if="indexTab !== 2 && tabCategory != 4">RIVAL</b-th>
							<b-th class="p-1" v-if="indexTab === 1">RESULTADO</b-th>
							<b-th class="p-1" v-if="id_specimen && tabCategory != 4">PUNTAJE RIVAL</b-th>
							<b-th class="p-1">FECHA</b-th>
							<b-th class="p-1">SUBIDO POR</b-th>
							<b-th class="p-1" v-if="isAdmin || isSupervisor || isPreparador">ACCIONES</b-th>
						</b-tr>
					</b-thead>

					<b-tbody>
						<b-tr class="text-center" v-for="(item, index) in items" :key="index">
							<b-td v-if="!id_specimen && isAdmin">
								<b-checkbox v-model="item.selected" />
							</b-td>
							<b-td v-if="id_specimen">
								<template v-for="(score, indexSc) in item.rival_specimens_score">
									<div :key="indexSc" v-if="score.id == id_specimen" class="d-flex flex-column">
										<div
											class="d-flex align-items-center justify-content-center cursor-pointer"
											@click="
												openEditQualifyModal(
													item,
													item[item.rival.id == id_specimen ? 'rival' : 'local'],
													score.user
												)
											"
										>
											<span class="text-primary font-weight-bolder" style="font-size: 16px">
												{{ score.score ? Number(score.score).toFixed(2) : "-" }}
											</span>
											<feather-icon
												icon="StarIcon"
												size="17"
												class="text-warning"
												style="margin-left: 5px"
											/>
										</div>
										<span>{{ score.user_name }}</span>
									</div>
								</template>
							</b-td>

							<b-td class="text-center">
								<div
									v-if="item.video.status == '2' && (item.video.url || item.video.aws_hls_url)"
									class="d-flex align-items-center justify-content-center"
								>
									<span @click="viewSpecimen(item, index)" style="cursor: pointer">
										<b-avatar
											:src="item.video.thumb"
											rounded
											size="80"
											icon="film"
											badge
											badge-variant="danger"
										>
											<template #badge>{{ item.video.duration }}</template>
										</b-avatar>
									</span>
									<div class="d-flex flex-column justify-content-center align-items-center ml-1">
										<feather-icon
											@click="selectBattle(item)"
											class="cursor-pointer"
											icon="Edit3Icon"
											size="18"
										/>
										<feather-icon
											class="cursor-pointer text-danger mt-1"
											icon="DownloadIcon"
											size="20"
											v-b-tooltip.hover="`Descargar`"
											@click="downloadVideo(item)"
											v-if="
												isAdmin &&
												item.video.status == '2' &&
												(item.video.url || item.video.aws_hls_url)
											"
										/>
									</div>
								</div>
								<div v-else-if="item.video.s3">
									<p class="mb-0">Procesando video</p>
								</div>
								<div v-else>
									<div v-if="item.category != 'torneo'">
										<b-button
											class="btn-icon"
											style="padding: 2px; margin: 0 0 4px 4px"
											variant="outline-primary"
											size="sm"
											title="Subir video de tope"
											v-b-tooltip.hover
											@click="selectBattle(item)"
										>
											<feather-icon class="cursor-pointer" size="16" icon="PlusIcon" />
										</b-button>
									</div>
									<UploadFightVideo v-else @refresh="refresh" :info="item" />
								</div>
							</b-td>

							<b-td v-if="!id_specimen" class="text-center">
								<template v-if="item.local">
									<template v-if="item.local && item.local.type == 'specimen'">
										<div class="d-flex align-items-center justify-content-center">
											<SpecimenPlate
												:specimen="{
													plate: item.local.plate,
													alias: item.local.alias,
													id: item.local.id,
													thumb: item.local.thumb,
													image: item.local.url,
												}"
												:is_specimen="item.local.type == 'specimen'"
												is_icon
												show_details_icon
												@image-clicked="handleImageClicked"
											/>
											<div class="position-relative">
												<feather-icon
													@click="openIncidenceModal(item.local)"
													:class="{ 'icon-disabled': item.local.incidences_qty === 0 }"
													v-b-tooltip.hover="
														item.local.incidences_qty > 0
															? 'Ver incidencias'
															: 'Sin incidencias'
													"
													class="text-primary"
													icon="AlertOctagonIcon"
													size="19"
													style="cursor: pointer"
												/>
												<span v-if="item.local.incidences_qty > 0" class="incidences-counter">
													{{ item.local.incidences_qty }}
												</span>
											</div>
										</div>
									</template>

									<template v-else>
										<SpecimenPlate
											:specimen="{
												plate: item.local.cintillo,
												alias: item.local.alias,
												id: item.local.id,
											}"
											:is_specimen="item.local.type == 'specimen'"
											is_icon
											show_details_icon
											@image-clicked="handleImageClicked"
										/>
									</template>
									<template v-if="!id_specimen">
										<span
											class="text-primary d-flex align-items-center justify-content-center cursor-pointer"
											v-for="(specimen, index) in item.rival_specimens_score.filter(
												(score) => score.id == item.local.id
											)"
											:key="`local-${index}`"
											@click="openEditQualifyModal(item, item.local, specimen.user)"
										>
											<span class="font-weight-bolder">{{ specimen.user_name }}:</span>
											<span class="font-weight-bolder ml-1">
												{{ specimen.score ? Number(specimen.score).toFixed(2) : "-" }}
											</span>
											<feather-icon
												class="cursor-pointer star-score text-warning mt-0"
												size="15"
												icon="StarIcon"
											/>
										</span>
									</template>
									<div
										v-if="!!item.local.status"
										class="d-flex align-items-center justify-content-center gap-x-1 mt-1"
									>
										<feather-icon
											size="18"
											v-b-tooltip.hover.top="
												item.local.in_galpon === 1 ? 'Disponible' : 'No disponible'
											"
											:class="{
												'text-danger': item.local.in_galpon === 0,
												'text-success': item.local.in_galpon === 1,
											}"
											:icon="item.local.in_galpon === 1 ? 'CheckCircleIcon' : 'XCircleIcon'"
										></feather-icon>
										<span>{{ item.local.status }}{{ item.local.trainingStatusName }}</span>
										<FeatherIcon
											v-if="item.local.training_group_id"
											:icon="item.local.trainingGroupIcon"
											size="18"
											v-b-tooltip.hover.top="`${item.local.trainingGroupName}`"
											class="text-primary"
										/>
									</div>
									<div v-if="!!item.local.trainer">
										<small>Preparador: {{ item.local.trainer }}</small>
									</div>
									<b-badge variant="light-primary" class="mt-1" v-if="item.reason_local.id">
										Motivo: {{ item.reason_local.name }}
									</b-badge>
								</template>
								<template v-else>
									<p class="mb-0">Sin rival</p>
								</template>
							</b-td>

							<b-td class="text-center" v-if="indexTab !== 2 && tabCategory != 4">
								<template v-if="item.rival">
									<template v-if="item.rival && item.rival.type == 'specimen'">
										<div class="d-flex align-items-center justify-content-center">
											<SpecimenPlate
												:specimen="{
													plate: item[item.rival.id == id_specimen ? 'local' : 'rival'].plate,
													alias: item[item.rival.id == id_specimen ? 'local' : 'rival'].alias,
													id: item[item.rival.id == id_specimen ? 'local' : 'rival'].id,
													thumb: item[item.rival.id == id_specimen ? 'local' : 'rival'].thumb,
													image: item[item.rival.id == id_specimen ? 'local' : 'rival'].url,
												}"
												:is_specimen="item.rival.type == 'specimen'"
												is_icon
												show_details_icon
												@image-clicked="handleImageClicked"
											/>
											<div class="position-relative">
												<feather-icon
													@click="
														openIncidenceModal(
															item[item.rival.id == id_specimen ? 'local' : 'rival']
														)
													"
													:class="{
														'icon-disabled':
															item[item.rival.id == id_specimen ? 'local' : 'rival']
																.incidences_qty === 0,
													}"
													v-b-tooltip.hover="
														item[item.rival.id == id_specimen ? 'local' : 'rival']
															.incidences_qty > 0
															? 'Ver incidencias'
															: 'Sin incidencias'
													"
													class="text-primary"
													icon="AlertOctagonIcon"
													size="19"
													style="cursor: pointer"
												/>
												<span
													v-if="
														item[item.rival.id == id_specimen ? 'local' : 'rival']
															.incidences_qty > 0
													"
													class="incidences-counter"
												>
													{{
														item[item.rival.id == id_specimen ? "local" : "rival"]
															.incidences_qty
													}}
												</span>
											</div>
										</div>
									</template>

									<template v-else-if="item.rival && item.rival.type == 'chick'">
										<SpecimenPlate
											:specimen="{
												plate: item.rival.cintillo,
												alias: item.rival.alias,
												id: item.rival.id,
											}"
											:is_specimen="item.rival.type == 'specimen'"
											is_icon
											show_details_icon
											@image-clicked="handleImageClicked"
										/>
									</template>

									<template v-else-if="item.rival && item.rival.type == 'other'">
										<p class="mb-0">{{ item.rival.name }}</p>
									</template>
									<template v-if="!id_specimen">
										<span
											class="text-primary d-flex align-items-center justify-content-center cursor-pointer"
											v-for="(specimen, index) in item.rival_specimens_score.filter(
												(score) => score.id == item.rival.id
											)"
											:key="`rival-${index}`"
											@click="openEditQualifyModal(item, item.rival, specimen.user)"
										>
											<span class="font-weight-bolder">{{ specimen.user_name }}:</span>
											<span class="font-weight-bolder ml-1">
												{{ specimen.score ? Number(specimen.score).toFixed(2) : "-" }}
											</span>
											<feather-icon
												class="cursor-pointer star-score text-warning mt-0"
												size="15"
												icon="StarIcon"
											/>
										</span>
									</template>

									<div
										v-if="!!item.rival.status"
										class="d-flex align-items-center justify-content-center gap-x-1 mt-1"
									>
										<feather-icon
											size="18"
											v-b-tooltip.hover.top="
												item[item.rival.id == id_specimen ? 'local' : 'rival'].in_galpon === 1
													? 'Disponible'
													: 'No disponible'
											"
											:class="{
												'text-danger':
													item[item.rival.id == id_specimen ? 'local' : 'rival'].in_galpon ===
													0,
												'text-success':
													item[item.rival.id == id_specimen ? 'local' : 'rival'].in_galpon ===
													1,
											}"
											:icon="
												item[item.rival.id == id_specimen ? 'local' : 'rival'].in_galpon === 1
													? 'CheckCircleIcon'
													: 'XCircleIcon'
											"
										></feather-icon>

										<span>
											{{ item[item.rival.id == id_specimen ? "local" : "rival"].status
											}}{{
												item[item.rival.id == id_specimen ? "local" : "rival"]
													.trainingStatusName
											}}
										</span>
										<FeatherIcon
											v-if="
												item[item.rival.id == id_specimen ? 'local' : 'rival'].training_group_id
											"
											:icon="
												item[item.rival.id == id_specimen ? 'local' : 'rival'].trainingGroupIcon
											"
											size="18"
											v-b-tooltip.hover.top="
												`${
													item[item.rival.id == id_specimen ? 'local' : 'rival']
														.trainingGroupName
												}`
											"
											class="text-primary"
										/>
									</div>
									<div v-if="!!item[item.rival.id == id_specimen ? 'local' : 'rival'].trainer">
										<small>
											Preparador:
											{{ item[item.rival.id == id_specimen ? "local" : "rival"].trainer }}
										</small>
									</div>
									<b-badge variant="light-primary" class="mt-1" v-if="item.reason_rival.id">
										Motivo:
										{{
											item.rival.id == id_specimen
												? item.reason_local.name
												: item.reason_rival.name
										}}
									</b-badge>
								</template>
								<template v-else>
									<p class="mb-0">Sin rival</p>
								</template>
							</b-td>

							<b-td v-if="indexTab === 1">
								<template v-if="item.result && item.result.id == 1">
									<span class="text-primary font-weight-bolder">TRIUNFO</span>
								</template>
								<template v-else-if="item.result && item.result.id == 2">
									<span class="text-warning font-weight-bolder">EMPATE</span>
								</template>
								<template v-else-if="item.result && item.result.id == 3">
									<span class="text-danger font-weight-bolder">DERROTA</span>
								</template>
							</b-td>

							<b-td v-if="id_specimen && tabCategory != 4">
								<template v-for="(score, indexSc) in item.rival_specimens_score">
									<div :key="indexSc" v-if="score.id != id_specimen" class="d-flex flex-column">
										<div
											class="d-flex align-items-center justify-content-center cursor-pointer"
											@click="
												openEditQualifyModal(
													item,
													item[item.rival.id == id_specimen ? 'local' : 'rival'],
													score.user
												)
											"
										>
											<span class="text-primary font-weight-bolder" style="font-size: 16px">
												{{ score.score ? Number(score.score).toFixed(2) : "-" }}
											</span>
											<feather-icon
												icon="StarIcon"
												size="17"
												class="text-warning"
												style="margin-left: 5px"
											/>
										</div>
										<span>{{ score.user_name }}</span>
									</div>
								</template>
							</b-td>

							<b-td class="text-center">
								<span v-if="item.date" class="text-capitalize">{{ item.date | myGlobalDayShort }}</span>
								<span v-else>---</span>
							</b-td>

							<b-td class="text-center">
								<span class="text-capitalize">
									{{ item.created.user }}
									<br />
									{{ item.created.date | myGlobalDateTime }}
								</span>
							</b-td>

							<b-td class="text-center" v-if="isAdmin || isSupervisor || isPreparador">
								<div class="d-flex justify-content-center align-items-center gap-x-2">
									<feather-icon
										class="cursor-pointer text-danger"
										icon="DownloadIcon"
										size="20"
										v-b-tooltip.hover="`Descargar`"
										@click="downloadVideo(item)"
										v-if="
											isAdmin &&
											item.video.status == '2' &&
											(item.video.url || item.video.aws_hls_url)
										"
									/>
									<template v-if="item.video.thumb">
										<feather-icon
											class="cursor-pointer"
											icon="EditIcon"
											size="20"
											v-b-tooltip.hover="`Actualizar`"
											@click="selectVideoToUpdate(item)"
										/>
										<QualifyTope
											:video="{ ...item.video, uid: item.video.url }"
											:info="{
												category: item.category,
												_curSpecimen: item.local,
												specimen: item.rival,
												rival_specimens_score: item.rival_specimens_score,
												training_rival: item.training_rival,
												confrontation_id: item.confrontation_id,
											}"
											v-if="tabCategory !== 4 && indexTab !== 2 && canQualifyTope(item)"
											:training_tope_id="0"
											@refresh="refresh"
										/>
									</template>
									<FeatherIcon
										v-if="item.category != 'torneo' && (isAdmin || isSupervisor || isPreparador)"
										v-b-tooltip.hover="`Eliminar`"
										icon="TrashIcon"
										size="20"
										class="cursor-pointer text-danger"
										@click="removedConfrontationVideo(item)"
									/>
								</div>
							</b-td>
						</b-tr>
						<b-tr v-if="items.length == 0">
							<b-td class="text-center font-weight-bolder" :colspan="id_specimen ? 6 : 7">
								Sin videos que mostrar
							</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>
			</div>

			<div class="mx-2 mb-2">
				<b-row>
					<b-col
						cols="12"
						sm="6"
						class="d-flexalign-items-centerjustify-content-center justify-content-sm-start"
					>
						<span class="text-muted">
							Mostrando {{ start_page }} a {{ to_page }} de {{ total_data }} registros
						</span>
					</b-col>
					<!-- Pagination -->
					<b-col
						cols="12"
						sm="6"
						class="d-flex align-items-center justify-content-center justify-content-sm-end"
					>
						<b-pagination
							v-model="current_page"
							:total-rows="total_data"
							:per-page="perpage"
							first-number
							last-number
							class="mb-0 mt-1 mt-sm-0"
							prev-class="prev-item"
							next-class="next-item"
						>
							<template #prev-text>
								<feather-icon icon="ChevronLeftIcon" size="18" />
							</template>
							<template #next-text>
								<feather-icon icon="ChevronRightIcon" size="18" />
							</template>
						</b-pagination>
					</b-col>
				</b-row>
			</div>
		</b-card>

		<b-modal
			id="modal-xl"
			ok-only
			ok-title="Accept"
			centered
			size="xl"
			title=""
			v-model="videoPlayerController"
			hide-footer
		>
			<b-embed type="video" aspect="21by9" controls allowfullscreen>
				<source :src="selectedVideoUrl" type="video/webm" />
			</b-embed>
		</b-modal>

		<b-modal
			v-if="updateVideo.show"
			:title="updateVideo.title"
			v-model="updateVideo.show"
			hide-footer
			no-close-on-backdrop
		>
			<UploadVideoBattle
				v-if="updateVideo.show"
				@resetTable="
					refresh()
					updateVideo.show = false
					updateVideo.info = null
				"
				:item="updateVideo.info"
				@cancel="
					updateVideo.show = false
					updateVideo.info = null
				"
			/>
		</b-modal>

		<b-sidebar v-model="sidebarFilters">
			<div class="container-sidebar">
				<h2 class="mb-2">Filtros de videos</h2>
				<div class="form-control-input">
					<p class="mb-0">Seleccionar fechas:</p>

					<flat-pickr
						v-model="rangeDate"
						class="form-control"
						:config="{ mode: 'range' }"
						placeholder="Seleccionar fechas"
						style="width: 100% !important"
					/>
				</div>

				<div class="mt-1">
					<label for="reason">Seleccionar motivo:</label>
					<v-select
						id="reason"
						v-model="reason_id"
						:options="reasons"
						label="name"
						:reduce="(option) => option.id"
						:clearable="false"
						:placeholder="'Seleccionar motivo...'"
					/>
				</div>

				<div class="container-btns">
					<button @click="keyEnter" class="btn btn-primary btn-buscar-pl mt-2">Filtrar datos</button>
					<button @click="resetFilters()" class="btn btn-outline-info btn-buscar-pl mt-2">
						Reset filtros
					</button>
				</div>
			</div>
		</b-sidebar>

		<b-modal
			v-if="modalAddVideoBySpecimen"
			hide-footer
			v-model="modalAddVideoBySpecimen"
			size="xmd"
			no-close-on-backdrop
			hide-header
			centered
		>
			<UploadSpecimenVideo
				@resetTable="refresh"
				@closing="modalAddVideoBySpecimen = false"
				:specimen_to_update_id="id_specimen"
				:isCapadaTab="indexTab === 2"
				:isTopeTab="indexTab === 0"
				:title="`Agregar video de ${indexTab === 2 ? 'capeada' : ''}${indexTab === 0 ? 'tope' : ''} `"
			/>
		</b-modal>

		<b-modal v-if="itemSelectToUpdate" v-model="toggleModalUpdateVideo" size="xmd" centered hide-footer hide-header>
			<UploadSpecimenVideo
				@closing="toggleModalUpdateVideo = false"
				@resetTable="resetModalUpdateVideo"
				:title="`Actualizar video del ejemplar ${
					itemSelectToUpdate.local.alias ? `${itemSelectToUpdate.local.alias} - ` : ''
				} ${itemSelectToUpdate.local.plate ? `(${itemSelectToUpdate.local.plate})` : null}`"
				:specimen_to_update_id="itemSelectToUpdate.local.id"
				reset="true"
				:data="itemSelectToUpdate"
			/>
		</b-modal>
		<EditQualifyModal
			v-if="showEditQualifyModal"
			@close="showEditQualifyModal = false"
			@refresh="refresh"
			:item="selectedToUpdateQualify"
			:specimen="selectedSpecimen"
		/>
		<TopesMultiplesModal
			v-if="showTopesMultiplesModal"
			@close="showTopesMultiplesModal = false"
			@refresh="getCounterDrafts"
		/>
		<TopeGroupsModal v-if="showTopeGroupsModal" @refresh="getCounterDrafts" @close="showTopeGroupsModal = false" />
		<SpecimenIncidencesModal
			v-if="incidenceModal.show"
			:show="incidenceModal.show"
			:info="incidenceModal.info"
			@closing="incidenceModal.show = false"
		/>
		<SlidersImageVideo
			v-if="imageSliderModal.open"
			:url="imageSliderModal.url"
			:type="imageSliderModal.type"
			:text="imageSliderModal.text"
			:text_url="imageSliderModal.text_url"
			:open="imageSliderModal.open"
			:idSpecimen="imageSliderModal.idSpecimen"
			@refreshSlider="closeImageSlider"
		/>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex"
import vSelect from "vue-select"
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"
import axios from "@/axios"
import Ripple from "vue-ripple-directive"
import VLazyImage from "v-lazy-image/v2"
import UploadSpecimenVideo from "./UploadSpecimenVideo.vue"
import UploadVideoBattle from "./UploadVideoBattle.vue"
import participantService from "@/views/brain/tournament/views/participants/participants.service"
import FlatPickr from "vue-flatpickr-component"
import { getTournaments, getSonsBySpecimen } from "@/services/reports.service"
import TopesReasonsService from "@/views/brain/others/views/topes/services/topesReasons.service.js"
import TopesMultiplesModal from "@/views/amg/videolibrary/confrontation-drafts/components/TopesMultiplesModal.vue"
import {
	getRivalsByName,
	getVideosSpecimen,
	removedConfrontation,
	removedConfrontationMultiple,
	getUrlForDownloadVideo,
	getCounterVideos,
} from "./service.videolibrary"
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
import QualifyTope from "@/views/amg/preparacion/components/QualifyTope.vue"
import UploadFightVideo from "./UploadFightVideo.vue"
import moment from "moment"
import EditQualifyModal from "@/views/amg/preparacion/components/EditQualifyModal.vue"
import ConfrontationDraftsService from "@/views/amg/videolibrary/confrontation-drafts/services/confrontation-drafts.service.js"
import SpecimenIncidencesModal from "@/views/amg/videolibrary/incidences/IncidencesModal.vue"
import TopeGroupsModal from "@/views/amg/videolibrary/confrontation-drafts/components/TopeGroupsModal.vue"
import SlidersImageVideo from "@/views/amg/header-bookmarks/SlidersImageVideo.vue"
export default {
	name: "VideoSpecimenList",
	directives: {
		Ripple,
	},
	components: {
		SlidersImageVideo,
		SpecimenIncidencesModal,
		vSelect,
		VLazyImage,
		UploadSpecimenVideo,
		UploadVideoBattle,
		FlatPickr,
		SpecimenPlate,
		QualifyTope,
		UploadFightVideo,
		EditQualifyModal,
		TopesMultiplesModal,
		TopeGroupsModal,
	},
	props: {
		id_specimen: {
			type: Number,
			default: null,
		},
		tabCategory: {
			type: Number,
			default: null,
		},
		origin: String,
	},
	data() {
		return {
			viewMode: "card", // 'table' or 'card'
			incidenceModal: {
				show: false,
				info: null,
			},
			imageSliderModal: {
				open: false,
				url: null,
				type: "image",
				text: null,
				text_url: null,
				idSpecimen: null,
			},
			showTopeGroupsModal: false,
			showTopesMultiplesModal: false,
			selectedSpecimen: null,
			selectedToUpdateQualify: null,
			showEditQualifyModal: false,
			indexTab: 0,
			loadingTable: false,
			itemSelectToUpdate: null,
			toggleModalUpdateVideo: false,
			sortBy: "created_at",
			counters: [],
			sortDesc: true,
			arrayColumns: [],
			data_sessions: [],
			modal_sessions: false,
			data: [],
			edit: [],
			list_users: true,
			create_update: false,
			disable: {
				save: false,
			},
			search_input: "",
			orderby: this.dato2 == null ? 3 : this.dato2,
			order: this.dato1 == null ? "desc" : this.dato1,
			start_page: 1,
			end_page: "",
			total_data: "",
			perpage: 100,
			next_page: "",
			current_page: 1,
			to_page: 2,
			dato1: "",
			dato2: "",
			loadingData: false,
			isBusy: false,
			selectedVideoUrl: null,
			videoPlayerController: false,
			perPageOptions: [10, 25, 50, 100],
			data_specimen: {
				type: "",
				url: "",
				plaque: "",
				alias: "",
				id: "",
				size: 300000000,
				last_left: false,
				last_right: false,
			},
			modal_image: false,
			index: null,
			selectUploadVideo: null,
			modalUploadVideo: false,
			modalUploadVideoTitle: null,
			date1In: null,
			date2In: null,
			tournamentIn: null,
			resultIn: null,
			originIn: null,
			pageIn: 1,
			perPageIn: 50,
			result: null,
			resultFilter: null,
			rivalIn: null,
			typeIn: null,
			tournaments: [
				{
					id: null,
					name: "TODOS",
				},
			],
			resultsArray: [
				{
					id: null,
					name: "TODOS",
				},
				{
					id: 1,
					name: "TRIUNFO",
				},
				{
					id: 2,
					name: "EMPATE",
				},
				{
					id: 3,
					name: "DERROTA",
				},
			],
			typeArray: [
				{
					id: null,
					name: "TODOS",
				},
				{
					id: 1,
					name: "INTERNO",
				},
				{
					id: 2,
					name: "EXTERNO",
				},
			],
			categoryArray: [
				// {
				// 	id: null,
				// 	name: "TODOS",
				//   disabled: false,
				// },
				{
					id: 1,
					name: "TOPE",
					disabled: false,
				},
				{
					id: 2,
					name: "PELEA",
					disabled: true,
				},
				{
					id: 3,
					name: "TORNEO",
					disabled: false,
				},
			],
			categoryIn: null,
			participant: null,
			participantArray: [
				{
					value: null,
					label: "TODOS",
				},
			],
			rivalsArray: [
				{
					value: null,
					label: "TODOS",
				},
			],
			sidebarFilters: false,
			dataSelectVideo: {
				url: null,
				type: null,
				text: null,
				text_url: null,
				open: false,
			},
			modalUploadVideo: false,
			selectUploadVideo: null,
			arrayMonths: [
				{
					name: "Enero",
					id: 1,
				},
				{
					name: "Febrero",
					id: 2,
				},
				{
					name: "Marzo",
					id: 3,
				},
				{
					name: "Abril",
					id: 4,
				},
				{
					name: "Mayo",
					id: 5,
				},
				{
					name: "Junio",
					id: 6,
				},
				{
					name: "Julio",
					id: 7,
				},
				{
					name: "Agosto",
					id: 8,
				},
				{
					name: "Setiembre",
					id: 9,
				},
				{
					name: "Octubre",
					id: 10,
				},
				{
					name: "Noviembre",
					id: 11,
				},
				{
					name: "Diciembre",
					id: 12,
				},
			],
			arrayYears: [],
			selectMonth: null,
			selectYear: null,
			clickIcon: false,
			rangeDate: null,
			modalAddVideoBySpecimen: false,
			specimenAliasList: null,
			items: [],
			updateVideo: {
				show: false,
				info: null,
				title: "",
			},
			reason_id: null,
			reasons: [],
			draftCounter: 0,
			filterByScore: null,
		}
	},
	computed: {
		...mapState("header_book", [
			"imagesVideoteca",
			"openModal",
			"uploadImages",
			"upload",
			"toggleOpenGallery",
			"indexImage",
		]),
		...mapState("video", ["videos", "uploading"]),
		tabId() {
			if (this.indexTab === 0) {
				return 1
			} else if (this.indexTab === 1) {
				return 3
			} else if (this.indexTab === 2) {
				return 4
			}
		},
		getCounterTope() {
			const tope = this.counters.find((it) => it.name === "tope")
			if (!tope) return 0
			return tope.counter
		},
		getCounterTournament() {
			const tournaments = this.counters.find((it) => it.name === "torneo")
			if (!tournaments) return 0
			return tournaments.counter
		},
		getCapeadaCounter() {
			const capeada = this.counters.find((it) => it.name === "CAPEADA")
			if (!capeada) return 0
			return capeada.counter
		},
	},
	async mounted() {
		this.getCounterDrafts()
		await this.isPreloading()
		await this.getCounters()
		this.getReasons()

		this.loadingTable = true
		if (this.tabCategory == 1) {
			this.categoryArray = this.categoryArray.map((item) => {
				if (item.id == 1) {
					item.disabled = true
				} else {
					item.disabled = false
				}
				return item
			})
		} else if (this.tabCategory == 2) {
			this.categoryArray = this.categoryArray.map((item) => {
				if (item.id == 2 || item.id == 3) {
					item.disabled = true
				} else {
					item.disabled = false
				}
				return item
			})
		} else {
			this.categoryArray = this.categoryArray.map((item) => {
				return {
					...item,
					disabled: true,
				}
			})
		}
		this.setVideoteca(true)

		await this.init()
		this.isPreloading(false)
	},
	methods: {
		handleImageClicked(item) {
			this.imageSliderModal = {
				open: true,
				text_url: `detalle/${item.id}`,
				type: "image",
				text: `${item.plate} ${item.alias ? "-" : ""} ${item.alias ? item.alias : ""}`,
				url: item.image ? item.image : "/rooster/rooster.jpg",
				idSpecimen: item.id,
			}
		},
		closeImageSlider() {
			this.imageSliderModal = {
				open: false,
				url: null,
				type: "image",
				text: null,
				text_url: null,
				idSpecimen: null,
			}
		},
		openIncidenceModal(item) {
			this.incidenceModal.info = item
			this.incidenceModal.show = true
		},
		async getCounterDrafts() {
			try {
				const { data } = await ConfrontationDraftsService.counterDrafts()
				this.draftCounter = data
			} catch (error) {
				console.error("Error fetching counter drafts:", error)
			}
		},
		getTrainingGroupIcon(group_id) {
			if (!group_id) return ""
			if (group_id === 1) return "AwardIcon"
			if (group_id === 2) return "GridIcon"
			return "UsersIcon"
		},
		getTrainingGroupName(group_id) {
			if (!group_id) return ""
			if (group_id === 1) return "Competitivo"
			if (group_id === 2) return "Otros"
		},
		getTrainingStatusName(status) {
			if (!status) return ""
			if (status === 1) {
				return "(EN PROCESO)"
			} else if (status === 2) {
				return "(PRE-LISTO)"
			} else if (status === 6) {
				return "(TRIP)"
			} else {
				return ""
			}
		},
		...mapActions("header_book", [
			"setImagesVideoteca",
			"toggleModal",
			"setIndexImage",
			"setTextImage",
			"setUploadImages",
			"deleteUploadFile",
			"toggleBgUpload",
			"initToggleUpload",
			"toggleModalGallery",
			"toggleUploadGallery",
			"setVideoteca",
		]),
		...mapActions({
			A_GET_DAYS_WITHOUT_TOPES_COUNTER: "commons/A_GET_DAYS_WITHOUT_TOPES_COUNTER",
		}),
		...mapMutations("video", ["M_RESET_FORM_VIDEO", "M_SET_VIDEOS", "M_SET_VIDEO_BY_ID"]),
		openEditQualifyModal(item, specimen, user_id) {
			this.selectedToUpdateQualify = item.rival_specimens_score.find(
				(score) => score.id == specimen.id && score.user == user_id
			)
			this.selectedSpecimen = {
				...specimen,
				confrontation_id: item.confrontation_id,
				qualities: item.qualities
					.filter(
						(quality) =>
							quality.type == "quality" &&
							quality.specimen_id == specimen.id &&
							quality.user_id == user_id
					)
					.map((quality) => quality.quality_id),
				characteristics: item.qualities
					.filter(
						(characteristic) =>
							characteristic.type == "characteristic" &&
							characteristic.specimen_id == specimen.id &&
							characteristic.user_id == user_id
					)
					.map((quality) => quality.quality_id),
			}
			this.showEditQualifyModal = true
		},
		async getCounters() {
			try {
				const { data } = await getCounterVideos({
					filter_without_score: this.filterByScore ? 1 : null,
				})
				this.counters = data.data
			} catch (error) {
				throw error
			}
		},
		async init() {
			this.isPreloading()
			this.loadingTable = true
			const dateArray = this.rangeDate && this.rangeDate.split(" to ")
			const {
				message,

				videos: { data, from, last_page, to, total },
			} = await getVideosSpecimen({
				category_id: this.tabCategory ? this.tabCategory : this.tabId,
				end_date: (dateArray && dateArray[1]) || this.date2In,
				start_date: (dateArray && dateArray[0]) || this.date1In,
				fight_result_id: null,
				result_id: this.resultIn,
				rival_id: this.rivalIn || this.participant,
				tournament_id: this.tournamentIn,
				search: this.search_input,
				page: this.current_page,
				perpage: this.perpage,
				group_category: null,
				specimen_id: this.id_specimen,
				reason_id: this.reason_id,
				filter_without_score: this.filterByScore ? 1 : null,
			})

			this.items = data.map((item) => {
				return {
					...item,
					local: {
						...item.local,
						trainingStatusName: this.getTrainingStatusName(item.local.training_status),
						trainingGroupName: this.getTrainingGroupName(item.local.training_group_id),
						trainingGroupIcon: this.getTrainingGroupIcon(item.local.training_group_id),
					},
					rival: {
						...item.rival,
						trainingStatusName: this.getTrainingStatusName(item.rival?.training_status),
						trainingGroupName: this.getTrainingGroupName(item.rival?.training_group_id),
						trainingGroupIcon: this.getTrainingGroupIcon(item.rival?.training_group_id),
					},
				}
			})
			// this.M_SET_VIDEOS(data);
			this.setImagesVideoteca(
				data.map((item) => {
					return {
						...item,
						id: item.fr_id,
						id_specimens: item.local.id,
						plate: item.local.plate,
						name: item.local.alias ? item.local.alias : "",
						preload: item.video.thumb,
						type: "video",
						url: item.video.url,
						aws_hls_url: item.video.aws_hls_url,
					}
				})
			)
			this.start_page = from
			this.end_page = last_page
			this.total_data = total
			this.to_page = to
			this.isPreloading(false)
		},
		viewSpecimen(item, index) {
			const local =
				item.local.type == "specimen"
					? `${item.local.alias ? item.local.alias : ""} (${item.local.plate})`
					: `${item.local.cintillo}`
			const rival =
				item.rival && item.rival.plate
					? `${item.rival.alias ? item.rival.alias : ""} (${item.rival.plate})`
					: item.rival
					? item.rival.cintillo || item.rival.name
					: "Sin rival"
			this.toggleModal()
			this.setTextImage({
				title: `${local} vs ${rival}`,
				url: `/ejemplares/detalle/${item.local.id}`,
			})
			this.setIndexImage(index)
		},
		closeModalimage() {
			this.modal_image = false
		},
		resetSearch() {
			this.init()
		},
		showToast(variant, position) {
			this.$toast(
				{
					component: ToastificationContent,
					props: {
						title: "Video eliminado!",
						icon: "InfoIcon",
						text: "El video fue eliminado correctamente!",
						variant,
					},
				},
				{
					position,
				}
			)
		},
		deleteVideo(data) {
			this.$swal({
				title: "Estás seguro?",
				text: "No podrás revertir esto!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Sí, eliminalo!",
				cancelButtonText: "Cancelar",
				customClass: {
					confirmButton: "btn btn-primary",
					cancelButton: "btn btn-outline-danger ml-1",
				},
				buttonsStyling: false,
			}).then((result) => {
				this.isPreloading()
				if (result.value) {
					axios
						.post("/api/delete-video", {
							id: data.video.id,
							iduser: this.currentUser.user_id,
							fightResult: data.fr_id,
							tournament_stage_specimen: data.tss_id,
						})
						.then(async (response) => {
							if (data.category == "TORNEO") {
								this.items = this.items.map((item) => {
									if (item.fr_id == data.fr_id) {
										return {
											...item,
											video: {
												duration: null,
												status: null,
												thumb: null,
												uid: null,
											},
										}
									} else {
										return item
									}
								})
							} else {
								// this.M_SET_VIDEOS(this.videos.filter((item) => item.id != data.id));
								this.items = this.items.filter((item) => item.fr_id != data.fr_id)

								// await this.init();
								this.to_page = this.to_page - 1
								this.total_data = this.total_data - 1
							}
							this.showToast("success", "top-right")
						})
						.catch((err) => {
							console.error(err)
						})
				}
				setTimeout(() => {
					this.isPreloading(false)
				}, 500)
			})
		},
		viewSpecimenVideo(item) {
			let index = this.videos.findIndex((x) => x.id == item.id)
			this.index = index
		},

		selectVideoToUpdate(item) {
			this.toggleModalUpdateVideo = true
			this.itemSelectToUpdate = item
		},
		async downloadVideo(item) {
			this.isPreloading()
			const fileName = `${item.category.toUpperCase()}_${item.local.plate.toUpperCase()}_${moment().format(
				"YYYY_MM_DD_HH_mm_ss"
			)}.mp4`
			try {
				const data = item.video.s3 || (await getUrlForDownloadVideo(item.id))
				const downloadLink = `${data}?filename=${fileName}`
				const link = document.createElement("a")
				link.href = downloadLink
				link.download = fileName
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},

		async resetModalUpdateVideo() {
			this.toggleModalUpdateVideo = false
			await this.refresh()
			setTimeout(() => {
				this.itemSelectToUpdate = null
			}, 300)
		},
		selectBattle(item) {
			this.updateVideo.show = true
			this.updateVideo.info = item
			this.updateVideo.title = `Actualizar video de ${
				item.local.plate || item.local.correlative || "Sin local"
			} vs ${item.rival.plate || item.rival.name || "Sin rival"}`
			// this.modalUploadVideo = true
			// this.selectUploadVideo = item
			// this.modalUploadVideoTitle = `Cargar video de ${item.entidad.plate} vs ${item.rival.alias}`
		},
		async refresh() {
			this.getCounters()
			await this.init()
			this.modalAddVideoBySpecimen = false
			this.modalUploadVideo = false
			this.$emit("refresh")
		},
		async searchParticipants(search, loading) {
			clearTimeout(this.debounce)
			this.debounce = setTimeout(async () => {
				loading(true)
				if (search.length > 1) {
					const {
						data: { data },
					} = await participantService.getContactsToStatus({
						pageIn: 1,
						perPageIn: 50,
						search: search,
						status: 0,
						type_id: 1,
					})
					this.participantArray = [
						...data.map((item) => {
							return {
								label: item.participant_name,
								value: item.id,
							}
						}),
					]
				}
				loading(false)
			}, 300)
		},

		async searchRival(search, loading) {
			clearTimeout(this.debounce)
			this.debounce = setTimeout(async () => {
				loading(true)
				if (search.length > 1) {
					const { data } = await getRivalsByName({
						search: search,
					})
					this.rivalsArray = data
				}
				loading(false)
			}, 300)
		},
		//keyEnter
		async resetFilters() {
			this.date1In = null
			this.date2In = null
			this.tournamentIn = null
			this.resultIn = null
			this.originIn = null
			this.selectMonth = null
			this.selectYear = null
			this.participant = null
			this.categoryIn = null
			this.participantIn = null
			this.rivalIn = null
			this.typeIn = null
			this.reason_id = null
			await this.init()
		},
		async keyEnter() {
			await this.init()
			this.sidebarFilters = false
		},
		async getTournamentsTotal() {
			const { data } = await getTournaments()
			this.tournaments = [...this.tournaments, ...data]
		},
		canQualifyTope(info) {
			if (!info.rival_specimens_score) return true
			if (info.local.type != "specimen") return false
			let userQualifier = info.rival_specimens_score.some((score) => score.user == this.currentUser.id)
			let specimenQualified = info.rival_specimens_score.some((score) => score.id == info.local.id)
			return !(userQualifier && specimenQualified)
		},
		async removedConfrontationVideo(item) {
			const { isConfirmed } = await this.showConfirmSwal({
				title: null,
				html: `
					<p class="mb-0">¿Desea eliminar el video de ${item.local.plate || item.local.correlative} vs ${
					item.rival.plate || item.rival.correlative || item.rival.name
				}?</p>
				`,
			})
			if (!isConfirmed) return
			this.isPreloading()
			await removedConfrontation({ id: item.confrontation_id })
			// refresh specimens with days without topes
			await this.A_GET_DAYS_WITHOUT_TOPES_COUNTER()

			this.isPreloading(false)
			this.refresh()
		},
		async removedConfrontationVideoMultiple() {
			const selectedVideos = this.items.filter((video) => video.selected)
			const { isConfirmed } = await this.showConfirmSwal({
				title: null,
				html: `
					<p class="mb-0">¿Desea eliminar ${selectedVideos.length} videos?</p>
				`,
			})
			if (!isConfirmed) return
			this.isPreloading()
			await removedConfrontationMultiple(selectedVideos.map((video) => video.confrontation_id))
			await this.A_GET_DAYS_WITHOUT_TOPES_COUNTER()
			this.isPreloading(false)
			this.refresh()
		},
		async getReasons() {
			try {
				const { data } = await TopesReasonsService.getTopesReasons({
					search: "",
				})
				this.reasons = data.data
			} catch (error) {
				console.log(error)
			}
		},
	},
	watch: {
		async current_page() {
			await this.init()
		},
		async perpage() {
			await this.init()
		},
		async modalAddVideoBySpecimen() {
			if (this.id_specimen) {
				const {
					data: [specimen],
				} = await getSonsBySpecimen({
					idSpecimen: parseInt(this.id_specimen),
				})
				this.specimenAliasList = specimen
			}
		},
		async sidebarFilters() {
			if (this.sidebarFilters && this.tournaments.length == 1) {
				await this.getTournamentsTotal()
			}
		},
		async indexTab() {
			await this.init()
		},
	},
	destroyed() {
		this.setVideoteca(false)
		this.setImagesVideoteca([])
		this.M_RESET_FORM_VIDEO({ category_idIn: 1, type_idIn: 1 })
		this.items = []
		this.M_SET_VIDEOS([])
	},
}
</script>

<style>
.b-avatar-badge.badge-danger {
	font-size: calc(11.4px) !important;
}
</style>
<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-sweetalert.scss";
.icon-disabled {
	pointer-events: none;
	opacity: 0.5;
}
.container-span {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.event-curos-none-list-video-specimen {
	cursor: not-allowed;
}

.w-cell {
	@media screen and (min-width: 62em) {
		max-width: 160px;
	}
}

.icon-cup {
	height: 30px;
	width: 30px;
}

.badge-glow {
	max-width: 60px;
	margin-left: 0.2rem;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.container-sidebar {
	padding: 0 1rem 1rem 1rem;

	.form-control-input {
		margin-bottom: 0.5rem;

		p {
			font-size: 12px;
		}
	}
}

.container-btns {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.incidences-counter {
	position: absolute;
	top: -0.4rem;
	left: 1.3rem;
	height: 1.2rem;
	min-width: 1.2rem;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 2px;
	background: var(--primary);
	border-radius: 0.2rem;
	font-weight: bolder;
	font-size: 12px;
}

.incidences-counter-footer {
	position: absolute;
	top: -0.3rem;
	right: -0.3rem;
	height: 1rem;
	min-width: 1rem;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0.15rem 0.35rem;
	background: var(--danger);
	border-radius: 0.75rem;
	font-weight: bold;
	font-size: 10px;
}

/* Card View Styles */
.videos-cards-grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
	gap: 1rem;
	padding-bottom: 1rem;

	@media (max-width: 576px) {
		grid-template-columns: 1fr;
	}

	@media (min-width: 577px) and (max-width: 992px) {
		grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
	}

	@media (min-width: 993px) and (max-width: 1400px) {
		grid-template-columns: repeat(auto-fill, minmax(420px, 1fr));
	}

	@media (min-width: 1401px) {
		grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
	}
}

.video-card {
	transition: transform 0.2s ease, box-shadow 0.2s ease;
	overflow: hidden;
	border: 2px solid #e0e0e0;
	border-radius: 0.5rem;
	display: flex;
	flex-direction: column;

	&:hover {
		transform: translateY(-4px);
		box-shadow: 0 4px 25px 0 rgba(34, 41, 47, 0.15);
	}

	.video-card-header {
		height: 310px;
		flex-shrink: 0;
		background: #f8f8f8;
		border-radius: 0.5rem 0.5rem 0 0;
		padding: 0;
		overflow: hidden;
	}

	.video-download-overlay {
		position: absolute;
		top: 8px;
		right: 40px;
		background: rgba(0, 0, 0, 0.6);
		border-radius: 50%;
		width: 32px;
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: background 0.2s ease;

		&:hover {
			background: rgba(0, 0, 0, 0.8);
		}
	}

	.video-edit-overlay {
		position: absolute;
		top: 8px;
		right: 8px;
		background: rgba(0, 0, 0, 0.6);
		border-radius: 50%;
		width: 32px;
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: background 0.2s ease;

		&:hover {
			background: rgba(0, 0, 0, 0.8);
		}
	}
}

/* Specimen Status Container with Ellipsis */
.specimen-status-container {
	flex-shrink: 0;
	max-width: 110px;
	align-self: flex-start;
	margin-top: -2px;

	.specimen-status-text {
		font-size: 9px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 70px;
		display: inline-block;
		line-height: 1.2;
	}

	.feather-icon,
	svg {
		width: 14px !important;
		height: 14px !important;
	}
}

.specimens-info-wrapper {
	display: flex;
	align-items: stretch;
	justify-content: space-between;
	gap: 1rem;
	flex: 1;
	min-height: 0;
}

.specimen-section {
	flex: 1;
	display: flex;
	flex-direction: column;
}

.specimen-section-label {
	display: flex;
	align-items: center;
	font-size: 11px;
	font-weight: bold;
	color: #5e5873;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	margin-bottom: 0.5rem;
	padding-left: 0.25rem;
}

.specimen-box {
	flex: 1;
	border: 2px solid #d8d6de;
	border-radius: 1rem;
	padding: 0.75rem;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	background: #ffffff;
}

.video-card-footer {
	height: 80px;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.5rem 0.75rem;

	.d-flex {
		font-size: 11px;
		line-height: 1.3;
	}
}
.status-badge {
	border: 1.5px solid #d4d4d4;
	background: #f8f8f8;
	color: #a0a0a0;
	border-radius: 0.5em;
	padding: 0rem 0.4rem;
	font-size: 11px;
	font-weight: 500;
}

.vs-divider {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	flex-shrink: 0;
	.vs-text {
		font-weight: bold;
		font-size: 18px;
		color: #6e6b7b;
		background: white;
		padding: 0.5rem;
		border-radius: 50%;
		border: 2px solid #d8d6de;
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
}

.gap-x-1 {
	gap: 0.5rem;
}

.py-50 {
	padding-top: 0.5rem !important;
	padding-bottom: 0.5rem !important;
}

/* Video Thumbnail Styles */
.video-thumbnail-card {
	width: 100%;
	height: 100%;
	border-radius: 0.5rem 0.5rem 0 0;
	object-fit: cover;
	display: block;
}

.video-play-overlay {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: rgb(255, 255, 255);
	border-radius: 50%;
	width: 70px;
	height: 70px;
	display: flex;
	align-items: center;
	justify-content: center;
	pointer-events: none;
	transition: all 0.3s ease;
	z-index: 1;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.video-play-overlay svg {
	color: black;
	fill: black;
	filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
	margin-left: 8px;
	transition: all 0.3s ease;
}

span:hover .video-play-overlay {
	background: rgba(0, 0, 0, 0.9);
	transform: translate(-50%, -50%) scale(1.1);
	box-shadow: 0 6px 20px rgba(0, 0, 0, 0.5);
}

span:hover .video-play-overlay svg {
	fill: white;
	color: white;
	filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.3));
}

.video-duration-badge {
	position: absolute;
	bottom: 8px;
	right: 8px;
	background: rgba(0, 0, 0, 0.8);
	color: white;
	padding: 0.25rem 0.5rem;
	border-radius: 0.25rem;
	font-size: 12px;
	font-weight: 600;
}

.video-result-badge {
	position: absolute;
	top: 8px;
	left: 8px;
	z-index: 2;

	.tournament-result-badge {
		font-size: 11px;
		font-weight: bold;
		padding: 0.4rem 0.75rem;
		border-radius: 0.25rem;
		text-transform: uppercase;
		letter-spacing: 0.5px;
	}
}

/* Tournament Info Styles */
.tournament-info-wrapper {
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
}

.tournament-specimen-section {
	display: flex;
	flex-direction: column;
}

.tournament-specimen-box {
	border: 2px solid #d8d6de;
	border-radius: 1rem;
	padding: 0.75rem 1rem;
	background: #ffffff;
}

.tournament-specimen-plate {
	flex-shrink: 0;
}

.tournament-details-grid {
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
	flex: 1;
}

/* Row with Calificación and Rival side by side */
.tournament-row-split {
	display: flex;
	gap: 0.75rem;
	width: 100%;
}

.tournament-detail-card-half {
	flex: 1;
	min-width: 0;
}

/* Calificación Card - Fondo amarillo/beige */
.tournament-qualification-card {
	background: #fef6ec;
	border-radius: 0.5rem;
	padding: 0.75rem;
	cursor: pointer;
	transition: all 0.2s ease;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	&:hover {
		background: #feefd8;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
	}

	&.disabled {
		cursor: default;
		opacity: 0.7;

		&:hover {
			background: #fef6ec;
			box-shadow: none;
		}
	}
}

.qualification-label {
	font-size: 10px;
	font-weight: 600;
	color: #7c6d5a;
	text-transform: capitalize;
	letter-spacing: 0.2px;
	margin-bottom: 0.5rem;
}

.qualification-content {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	margin-bottom: 0.4rem;
}

.qualification-star {
	color: #ff9f43;
}

.qualification-score {
	font-size: 22px;
	font-weight: bold;
	color: #3e3e3e;
}

.qualification-user {
	font-size: 12px;
	font-weight: 600;
	color: #3e3e3e;
	text-transform: capitalize;
}

/* Rival Card - Fondo azul claro */
.tournament-rival-card {
	background: #e8f4fd;
	border-radius: 0.5rem;
	padding: 0.75rem;
	height: 100%;
	display: flex;
	flex-direction: column;
}

.rival-label {
	font-size: 10px;
	font-weight: 600;
	color: #5a7c8d;
	text-transform: capitalize;
	letter-spacing: 0.2px;
	margin-bottom: 0.5rem;
}

.rival-content {
	flex: 1;
	display: flex;
	align-items: center;
}

.rival-name {
	font-size: 14px;
	font-weight: bold;
	color: rgba(0, 0, 255, 0.534);
	text-transform: uppercase;
}

/* Preparador Row - Sin fondo de color */
.tournament-preparador-row {
	display: flex;
	align-items: center;
	gap: 0.75rem;
	padding: 0.5rem 0.25rem;
}

.preparador-label {
	font-size: 11px;
	font-weight: 600;
	color: #7c6d5a;
	text-transform: capitalize;
	letter-spacing: 0.2px;
	min-width: 80px;
}

.preparador-value {
	font-size: 13px;
	font-weight: 600;
	color: #3e3e3e;
	text-transform: uppercase;
}

/* ============================================ */
/* CAPEADAS STYLES (Tab 2) */
/* ============================================ */
.capeadas-info-wrapper {
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
}

.capeadas-specimen-section {
	display: flex;
	flex-direction: column;
}

.capeadas-specimen-box {
	border: 2px solid #d8d6de;
	border-radius: 1rem;
	padding: 0.75rem 1rem;
	background: #ffffff;
}

.capeadas-specimen-plate {
	flex-shrink: 0;
}

.capeadas-details-grid {
	display: flex;
	justify-content: space-between;
	flex: 1;
}

.capeadas-detail-row {
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
}

.capeadas-label {
	font-size: 10px;
	font-weight: 600;
	color: #7c6d5a;
	text-transform: capitalize;
	letter-spacing: 0.2px;
}

.capeadas-value {
	font-size: 13px;
	font-weight: 600;
	color: #3e3e3e;
	text-transform: uppercase;
}

.capeadas-status-container {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	flex-wrap: wrap;
}

.capeadas-custom-badge {
	font-size: 10px;
	font-weight: bold;
	padding: 0.35rem 0.6rem;
	border-radius: 0.375rem;
	text-transform: uppercase;
	letter-spacing: 0.3px;
	border: 1px solid;
	display: flex;
	gap: 0.25rem;
	align-items: center;
}

.capeadas-badge-success {
	background-color: #d4edda;
	border-color: #28a745;
}

.capeadas-badge-danger {
	background-color: #f8d7da;
	border-color: #dc3545;
}

.capeadas-status-badge {
	font-size: 10px;
	font-weight: bold;
	padding: 0.35rem 0.6rem;
	border-radius: 0.375rem;
	text-transform: uppercase;
	letter-spacing: 0.3px;
}

.capeadas-status-text {
	font-size: 12px;
	font-weight: 600;
	color: #3e3e3e;
}

/* Legacy styles kept for compatibility */
.tournament-detail-card {
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
}

.tournament-card-label {
	font-size: 10px;
	font-weight: 600;
	color: #7c6d5a;
	text-transform: capitalize;
	letter-spacing: 0.2px;
	padding-left: 0.25rem;
}

.tournament-card-content-box {
	background: #ecfafe;
	border-radius: 0.5rem;
	padding: 0.65rem 0.75rem;
	min-height: 42px;
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
}

.tournament-card-value {
	font-size: 13px;
	font-weight: 600;
	color: #3e3e3e;
	text-transform: uppercase;
}

.tournament-score-badge {
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	transition: all 0.2s ease;
	padding: 0.15rem 0;

	&:hover {
		opacity: 0.8;
	}

	&:not(:last-child) {
		border-bottom: 1px solid #f0e5d8;
		padding-bottom: 0.4rem;
		margin-bottom: 0.25rem;
	}
}

.tournament-badge-user {
	font-size: 11px;
	font-weight: 600;
	color: #3e3e3e;
}

.tournament-badge-score {
	display: flex;
	align-items: center;
	gap: 0.3rem;
}

.tournament-badge-number {
	font-size: 15px;
	font-weight: bold;
	color: #3e3e3e;
}

.tournament-badge-star {
	color: #ff9f43;
}

.tournament-no-data {
	font-size: 12px;
	color: #999;
	font-style: italic;
	text-align: center;
}

/* Legacy styles (kept for backward compatibility) */
.tournament-info-items {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	flex: 1;
	padding-left: 1rem;
}

.tournament-info-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.35rem 0;
	border-bottom: 1px solid #f0f0f0;

	&:last-child {
		border-bottom: none;
	}
}

.tournament-info-label {
	font-size: 10px;
	font-weight: 600;
	color: #7c6d5a;
	text-transform: capitalize;
	min-width: 80px;
}

.tournament-info-value {
	font-size: 13px;
	font-weight: 500;
	color: #3e3e3e;
	text-align: right;
	text-transform: uppercase;
}

.tournament-score-value {
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	align-items: flex-end;
}

.tournament-score-item {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	background: #fef6ec;
	padding: 0.25rem 0.5rem;
	border-radius: 0.25rem;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		background: #feefd8;
	}
}

.tournament-score-user {
	font-size: 11px;
	font-weight: 600;
	color: #3e3e3e;
}

.tournament-score-number-container {
	display: flex;
	align-items: center;
	gap: 0.25rem;
}

.tournament-score-number {
	font-size: 13px;
	font-weight: bold;
	color: #3e3e3e;
}

.tournament-score-star {
	color: #ff9f43;
}

.tournament-no-score {
	font-size: 12px;
	color: #999;
	font-style: italic;
}

/* Specimen Score Card Styles */
.specimen-score-card {
	background: #fef6ec;
	border: none;
	border-radius: 0.375rem;
	padding: 0.5rem 0.65rem;
	cursor: pointer;
	transition: all 0.2s ease;
	width: 100%;

	&:hover {
		background: #feefd8;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
	}

	.score-label {
		font-size: 10px;
		font-weight: 600;
		color: #7c6d5a;
		text-transform: capitalize;
		letter-spacing: 0.2px;
		margin-bottom: 0.3rem;
		text-align: left;
	}

	.score-value-container {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.score-user {
		font-size: 13px;
		font-weight: 600;
		color: #3e3e3e;
		text-align: left;
	}

	.score-value {
		display: flex;
		align-items: center;
		gap: 0.3rem;
	}

	.score-number {
		font-size: 16px;
		font-weight: bold;
		color: #3e3e3e;
	}

	.score-star {
		color: #ff9f43;
	}
}

.specimen-score-card-disabled {
	cursor: default;
	opacity: 0.7;

	&:hover {
		background: #fef6ec;
		box-shadow: none;
	}
}

/* Specimen Info Badge Styles */
.specimen-info-badge {
	background: transparent;
	border: none;
	border-radius: 0;
	padding: 0.5rem 0.65rem;
	display: flex;
	flex-direction: column;
	gap: 0.2rem;
	width: 100%;

	.info-badge-label {
		font-size: 10px;
		font-weight: 600;
		color: #7c6d5a;
		text-transform: capitalize;
		letter-spacing: 0.2px;
		text-align: left;
	}

	.info-badge-value {
		font-size: 13px;
		font-weight: 500;
		color: #3e3e3e;
		text-align: left;
		text-transform: uppercase;
	}
}
</style>
